
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8qkba", function(module, exports) {
var $469284ca9bfa96d3$export$da638b84af7eb6eb = /*#__PURE__*/ function(CoverPictureIdPropertyKey) {
    CoverPictureIdPropertyKey["PUBLISHED"] = "cover-picture-id-published";
    CoverPictureIdPropertyKey["DRAFT"] = "cover-picture-id-draft";
    return CoverPictureIdPropertyKey;
}({});
function $469284ca9bfa96d3$export$da000b5ddbbe9afc(p) {
    let value;
    let version;
    const DEFAULT_POSITION_VALUE = 50;
    try {
        value = JSON.parse(p.value);
        version = p.version ? parseInt(JSON.parse(p.version.number)) : null;
        // Counting quotes to determine if the value we receive is a string (old cover photos experience without repositioning feature)
        // or object (new cover photos experience with repositioning feature - has a position property in the object).
        // The new designs will have value as an object but stored as a string: "{"id":"http://website.com","position":45}"
        // We need to JSON.parse it again to turn it into an object. The old cover photos will just have value as a string: value: "123-abc",
        // so there is no need to JSON parse it again. We will set its position as the default position value to support this new value format.
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this mean value is part of the new experience so we need to JSON parse the info again since it is a stored as a string and we want the object
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (e) {
            value = null;
        }
        else // otherwise it was just a regular string (part of old experience without repositioning)
        value = {
            id: value,
            position: DEFAULT_POSITION_VALUE
        };
    } catch (e) {
        value = null;
        version = null;
    }
    return p ? {
        value: value,
        version: version
    } : null;
}
module.exports["CoverPictureIdPropertyKey"] = $469284ca9bfa96d3$export$da638b84af7eb6eb;
module.exports["propertyToId"] = $469284ca9bfa96d3$export$da000b5ddbbe9afc;

});

parcelRegister("k2pUk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iwjSV = parcelRequire("iwjSV");


var $9DHhW = parcelRequire("9DHhW");


var $jWbXj = parcelRequire("jWbXj");


var $9BXp4 = parcelRequire("9BXp4");

var $hjUDQ = parcelRequire("hjUDQ");

var $hiHdh = parcelRequire("hiHdh");

var $bIp5p = parcelRequire("bIp5p");


var $dBD3L = parcelRequire("dBD3L");


var $ikd73 = parcelRequire("ikd73");

const $9cc1dc91c0ab8fca$export$669fadbeb0d65b03 = {
    backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
    textColor: "var(--ds-text, #292A2E)"
};
const $9cc1dc91c0ab8fca$var$getNewCardImage = (cardsLength)=>{
    const imageIndex = cardsLength % (0, $dBD3L.CARDS_IMAGES_V5).length;
    const { src: src, alt: alt } = (0, $dBD3L.CARDS_IMAGES_V5)[imageIndex] || (0, $dBD3L.CARDS_IMAGES_V5)[0];
    return {
        imageSrc: src,
        imageAltText: alt
    };
};
const $9cc1dc91c0ab8fca$export$d4fe2f2056b6479c = (defaultField)=>{
    return {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        cardId: (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))(),
        link: '',
        isLinkUserEdited: false,
        title: '',
        isTitleUserEdited: false,
        description: '',
        isDescriptionUserEdited: false,
        imagePosition: (0, $ikd73.ImagePosition).MIDDLE,
        ...defaultField
    };
};
const $9cc1dc91c0ab8fca$export$721510bd2cdb9b4f = (link, confluencePageId, isLinkUserEdited, linkResourceType)=>{
    return {
        [(0, $hjUDQ.ITEM_FIELDS).LINK]: link,
        [(0, $hjUDQ.ITEM_FIELDS).CONFLUENCE_PAGE_ID]: confluencePageId || '',
        [(0, $hjUDQ.ITEM_FIELDS).IS_LINK_USER_EDITED]: isLinkUserEdited || false,
        [(0, $hjUDQ.ITEM_FIELDS).LINK_RESOURCE_TYPE]: linkResourceType || ''
    };
};
const $9cc1dc91c0ab8fca$var$fetchLocalIdMacroParameters = (editorActions, localId)=>{
    const localIdNode = editorActions?.getNodeByLocalId?.(localId)?.toJSON();
    let params = localIdNode?.attrs?.parameters;
    if (params === undefined) return undefined;
    // Make a copy of the params object to avoid mutating the original object
    params = {
        ...params
    };
    // If the extension was created prior to removal of type field, remove it from object here
    // This update is/was not done in combination with a feature gate
    delete params['type'];
    params = $9cc1dc91c0ab8fca$var$migrateParamsToLatestVersion(params);
    return params;
};
/**
 * Migrates card extension parameters to the latest version by applying
 * default values for any missing properties introduced in each version.
 */ const $9cc1dc91c0ab8fca$var$migrateParamsToLatestVersion = (params)=>{
    var // Version 2 defaults
    _params, // Version 3 defaults
    _params1, _params2, _params3, // Version 4 defaults
    _params4, _params5, _params6, _params7, _params8, // Version 5 defaults
    _params9, _params10, _params11, _params12;
    (_params = params).renderVariant ?? (_params.renderVariant = (0, $hjUDQ.RenderVariant).MANUAL);
    (_params1 = params).isAutoscrollEnabled ?? (_params1.isAutoscrollEnabled = false);
    (_params2 = params).orientation ?? (_params2.orientation = (0, $ikd73.Orientation).STACKED);
    (_params3 = params).alignment ?? (_params3.alignment = (0, $ikd73.Alignment).CENTER);
    if (params.segmentationTarget === (0, $hjUDQ.SegmentationTargets).ALL && params.audienceSegmentationGroupIds === undefined) params.audienceSegmentationGroupIds = params.cards[0]?.audienceSegmentationGroupIds;
    (_params4 = params).backgroundColor ?? (_params4.backgroundColor = "var(--ds-surface-overlay, #FFFFFF)");
    (_params5 = params).textColor ?? (_params5.textColor = "var(--ds-text, #292A2E)");
    (_params6 = params).cornerStyle ?? (_params6.cornerStyle = (0, $hjUDQ.CornerStyle).ROUNDED);
    (_params7 = params).isSocialStatsShown ?? (_params7.isSocialStatsShown = false);
    (_params8 = params).isIconShown ?? (_params8.isIconShown = false);
    (_params9 = params).layout ?? (_params9.layout = (0, $ikd73.CardsLayout).FLEXIBLE_IMAGE_HEIGHT);
    (_params10 = params).isPaddingEnabled ?? (_params10.isPaddingEnabled = true);
    (_params11 = params).isLabelShown ?? (_params11.isLabelShown = true);
    (_params12 = params).borderColor ?? (_params12.borderColor = (0, $jWbXj.DEFAULT_GRAY_COLOR));
    // Set to latest version
    params.version = (0, $dBD3L.CARDS_EXTENSION_VERSION_5);
    return params;
};
const $9cc1dc91c0ab8fca$var$removeProperties = (extensionsPropertiesToRemove, extensionParameters)=>{
    const mutatedParameters = {
        ...extensionParameters
    };
    extensionsPropertiesToRemove.forEach((field)=>{
        delete mutatedParameters[field];
    });
    return mutatedParameters;
};
const $9cc1dc91c0ab8fca$var$updateCardInList = (cards, cardId, updatedField)=>cards.map((card)=>{
        if (card.cardId === cardId) return {
            ...card,
            ...updatedField
        };
        return card;
    });
const $9cc1dc91c0ab8fca$export$3c876d2ed5ae458e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(51);
    const { localId: localId, editorActions: editorActions } = t0;
    let t1;
    if ($[0] !== editorActions || $[1] !== localId) {
        t1 = $9cc1dc91c0ab8fca$var$fetchLocalIdMacroParameters(editorActions, localId);
        $[0] = editorActions;
        $[1] = localId;
        $[2] = t1;
    } else t1 = $[2];
    const [cardsParameters, setExtensionParameters] = (0, $cozmU.useState)(t1);
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId } = (0, $bIp5p.useExtensionsActions)();
    let t2;
    if ($[3] !== cardsParameters) {
        t2 = cardsParameters ?? {};
        $[3] = cardsParameters;
        $[4] = t2;
    } else t2 = $[4];
    const { cards: cards, segmentationTarget: segmentationTarget, isSegmentationShown: isSegmentationShown } = t2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t3;
    let t4;
    if ($[5] !== editorActions || $[6] !== localId) {
        t3 = ()=>{
            const extensionNodeParams = $9cc1dc91c0ab8fca$var$fetchLocalIdMacroParameters(editorActions, localId);
            setExtensionParameters(extensionNodeParams);
        };
        t4 = [
            editorActions,
            localId
        ];
        $[5] = editorActions;
        $[6] = localId;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== createAnalyticsEvent || $[10] !== editorActions) {
        t5 = (newExtensionParameters, t6)=>{
            const options = t6 === undefined ? {} : t6;
            setExtensionParameters((prevParams)=>{
                let mutatedFields = {
                    ...prevParams
                };
                const fieldsToRemove = [
                    ...options?.fieldsToRemove || []
                ];
                if (fieldsToRemove.length > 0) mutatedFields = $9cc1dc91c0ab8fca$var$removeProperties(fieldsToRemove, prevParams);
                const updatedParams = {
                    ...mutatedFields,
                    ...newExtensionParameters
                };
                const success = (0, $hiHdh.updateNodeParameters)(editorActions, updatedParams);
                if (!success) createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        source: "cardsExtension",
                        action: "error",
                        actionSubject: "cardsConfigPanel",
                        attributes: {
                            updatedFields: newExtensionParameters,
                            version: updatedParams.version
                        }
                    }
                }).fire();
                return updatedParams;
            });
        };
        $[9] = createAnalyticsEvent;
        $[10] = editorActions;
        $[11] = t5;
    } else t5 = $[11];
    const updateExtensionParams = t5;
    let t6;
    if ($[12] !== cards || $[13] !== isSegmentationShown || $[14] !== segmentationTarget || $[15] !== setIsInAutoFocusMode || $[16] !== setSelectedToEditCardId || $[17] !== updateExtensionParams) {
        t6 = ()=>{
            const newCard = $9cc1dc91c0ab8fca$export$d4fe2f2056b6479c({
                [(0, $hjUDQ.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: isSegmentationShown && segmentationTarget === (0, $hjUDQ.SegmentationTargets).ALL ? cards[0]?.audienceSegmentationGroupIds : undefined,
                ...$9cc1dc91c0ab8fca$var$getNewCardImage(cards.length)
            });
            updateExtensionParams({
                cards: [
                    ...(0, $9BXp4.checkItems)(cards) || [],
                    newCard
                ]
            });
            setIsInAutoFocusMode(true);
            setSelectedToEditCardId(newCard.cardId);
        };
        $[12] = cards;
        $[13] = isSegmentationShown;
        $[14] = segmentationTarget;
        $[15] = setIsInAutoFocusMode;
        $[16] = setSelectedToEditCardId;
        $[17] = updateExtensionParams;
        $[18] = t6;
    } else t6 = $[18];
    const addCard = t6;
    let t7;
    if ($[19] !== cards || $[20] !== updateExtensionParams) {
        t7 = (cardId)=>updateExtensionParams({
                cards: cards.filter((card)=>card.cardId !== cardId)
            });
        $[19] = cards;
        $[20] = updateExtensionParams;
        $[21] = t7;
    } else t7 = $[21];
    const removeCard = t7;
    let t8;
    if ($[22] !== updateExtensionParams) {
        t8 = (updatedFields, t9)=>{
            const options_0 = t9 === undefined ? {} : t9;
            return updateExtensionParams(updatedFields, options_0);
        };
        $[22] = updateExtensionParams;
        $[23] = t8;
    } else t8 = $[23];
    const updateMainFormField = t8;
    let t9;
    if ($[24] !== cards || $[25] !== updateExtensionParams) {
        t9 = (cardId_0, updatedField)=>{
            const updatedCards = $9cc1dc91c0ab8fca$var$updateCardInList(cards, cardId_0, updatedField);
            updateExtensionParams({
                cards: updatedCards
            });
        };
        $[24] = cards;
        $[25] = updateExtensionParams;
        $[26] = t9;
    } else t9 = $[26];
    const updateCardFormField = t9;
    let t10;
    if ($[27] !== cards || $[28] !== updateExtensionParams) {
        t10 = (updatedField_0)=>{
            const updatedCards_0 = cards.map((card_0)=>({
                    ...card_0,
                    ...updatedField_0
                }));
            updateExtensionParams({
                cards: updatedCards_0
            });
        };
        $[27] = cards;
        $[28] = updateExtensionParams;
        $[29] = t10;
    } else t10 = $[29];
    const updateCardFormFieldForAllCards = t10;
    let t11;
    if ($[30] !== updateExtensionParams) {
        t11 = (newLayout)=>{
            updateExtensionParams({
                layout: newLayout
            });
        };
        $[30] = updateExtensionParams;
        $[31] = t11;
    } else t11 = $[31];
    const updateLayout = t11;
    let t12;
    if ($[32] !== updateExtensionParams) {
        t12 = (newBorderColor)=>{
            updateExtensionParams({
                borderColor: newBorderColor
            });
        };
        $[32] = updateExtensionParams;
        $[33] = t12;
    } else t12 = $[33];
    const updateBorderColor = t12;
    let t13;
    if ($[34] !== updateExtensionParams) {
        t13 = (newCornerStyle)=>{
            updateExtensionParams({
                cornerStyle: newCornerStyle
            });
        };
        $[34] = updateExtensionParams;
        $[35] = t13;
    } else t13 = $[35];
    const updateCornerStyle = t13;
    let t14;
    if ($[36] !== updateExtensionParams) {
        t14 = (newCornerRadius)=>{
            updateExtensionParams({
                cornerRadius: newCornerRadius
            });
        };
        $[36] = updateExtensionParams;
        $[37] = t14;
    } else t14 = $[37];
    const updateCornerRadius = t14;
    let t15;
    if ($[38] !== addCard || $[39] !== removeCard || $[40] !== updateBorderColor || $[41] !== updateCardFormField || $[42] !== updateCardFormFieldForAllCards || $[43] !== updateCornerRadius || $[44] !== updateCornerStyle || $[45] !== updateLayout || $[46] !== updateMainFormField) {
        t15 = {
            addCard: addCard,
            removeCard: removeCard,
            updateMainFormField: updateMainFormField,
            updateCardFormField: updateCardFormField,
            updateCardFormFieldForAllCards: updateCardFormFieldForAllCards,
            updateLayout: updateLayout,
            updateBorderColor: updateBorderColor,
            updateCornerRadius: updateCornerRadius,
            updateCornerStyle: updateCornerStyle
        };
        $[38] = addCard;
        $[39] = removeCard;
        $[40] = updateBorderColor;
        $[41] = updateCardFormField;
        $[42] = updateCardFormFieldForAllCards;
        $[43] = updateCornerRadius;
        $[44] = updateCornerStyle;
        $[45] = updateLayout;
        $[46] = updateMainFormField;
        $[47] = t15;
    } else t15 = $[47];
    const cardsActions = t15;
    let t16;
    if ($[48] !== cardsActions || $[49] !== cardsParameters) {
        t16 = {
            cardsParameters: cardsParameters,
            cardsActions: cardsActions
        };
        $[48] = cardsActions;
        $[49] = cardsParameters;
        $[50] = t16;
    } else t16 = $[50];
    return t16;
} : ({ localId: localId, editorActions: editorActions })=>{
    const [cardsParameters, setExtensionParameters] = (0, $cozmU.useState)($9cc1dc91c0ab8fca$var$fetchLocalIdMacroParameters(editorActions, localId));
    const { setIsInAutoFocusMode: setIsInAutoFocusMode, setSelectedToEditCardId: setSelectedToEditCardId } = (0, $bIp5p.useExtensionsActions)();
    const { cards: cards, segmentationTarget: segmentationTarget, isSegmentationShown: isSegmentationShown } = cardsParameters ?? {};
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const extensionNodeParams = $9cc1dc91c0ab8fca$var$fetchLocalIdMacroParameters(editorActions, localId);
        setExtensionParameters(extensionNodeParams);
    }, [
        editorActions,
        localId
    ]);
    const updateExtensionParams = (0, $cozmU.useCallback)((newExtensionParameters, options = {})=>{
        setExtensionParameters((prevParams)=>{
            let mutatedFields = {
                ...prevParams
            };
            const fieldsToRemove = [
                ...options?.fieldsToRemove || []
            ];
            if (fieldsToRemove.length > 0) mutatedFields = $9cc1dc91c0ab8fca$var$removeProperties(fieldsToRemove, prevParams);
            const updatedParams = {
                ...mutatedFields,
                ...newExtensionParameters
            };
            // Save params to ADF and state
            const success = (0, $hiHdh.updateNodeParameters)(editorActions, updatedParams);
            if (!success) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'cardsExtension',
                    action: 'error',
                    actionSubject: 'cardsConfigPanel',
                    attributes: {
                        updatedFields: newExtensionParameters,
                        version: updatedParams.version
                    }
                }
            }).fire();
            return updatedParams;
        });
    }, [
        editorActions,
        createAnalyticsEvent
    ]);
    const addCard = (0, $cozmU.useCallback)(()=>{
        const newCard = $9cc1dc91c0ab8fca$export$d4fe2f2056b6479c({
            [(0, $hjUDQ.ITEM_FIELDS).AUDIENCE_SEGMENTATION_GROUP_IDS]: isSegmentationShown && segmentationTarget === (0, $hjUDQ.SegmentationTargets).ALL ? cards[0]?.audienceSegmentationGroupIds : undefined,
            ...$9cc1dc91c0ab8fca$var$getNewCardImage(cards.length)
        });
        updateExtensionParams({
            cards: [
                ...(0, $9BXp4.checkItems)(cards) || [],
                newCard
            ]
        });
        setIsInAutoFocusMode(true);
        setSelectedToEditCardId(newCard.cardId);
    }, [
        cards,
        segmentationTarget,
        isSegmentationShown,
        updateExtensionParams,
        setSelectedToEditCardId,
        setIsInAutoFocusMode
    ]);
    const removeCard = (0, $cozmU.useCallback)((cardId)=>updateExtensionParams({
            cards: cards.filter((card)=>card.cardId !== cardId)
        }), [
        cards,
        updateExtensionParams
    ]);
    const updateMainFormField = (0, $cozmU.useCallback)((updatedFields, options_0 = {})=>updateExtensionParams(updatedFields, options_0), [
        updateExtensionParams
    ]);
    const updateCardFormField = (0, $cozmU.useCallback)((cardId_0, updatedField)=>{
        const updatedCards = $9cc1dc91c0ab8fca$var$updateCardInList(cards, cardId_0, updatedField);
        updateExtensionParams({
            cards: updatedCards
        });
    }, [
        cards,
        updateExtensionParams
    ]);
    const updateCardFormFieldForAllCards = (0, $cozmU.useCallback)((updatedField_0)=>{
        const updatedCards_0 = cards.map((card_0)=>{
            return {
                ...card_0,
                ...updatedField_0
            };
        });
        updateExtensionParams({
            cards: updatedCards_0
        });
    }, [
        cards,
        updateExtensionParams
    ]);
    const updateLayout = (0, $cozmU.useCallback)((newLayout)=>{
        updateExtensionParams({
            layout: newLayout
        });
    }, [
        updateExtensionParams
    ]);
    const updateBorderColor = (0, $cozmU.useCallback)((newBorderColor)=>{
        updateExtensionParams({
            borderColor: newBorderColor
        });
    }, [
        updateExtensionParams
    ]);
    const updateCornerStyle = (0, $cozmU.useCallback)((newCornerStyle)=>{
        updateExtensionParams({
            cornerStyle: newCornerStyle
        });
    }, [
        updateExtensionParams
    ]);
    const updateCornerRadius = (0, $cozmU.useCallback)((newCornerRadius)=>{
        updateExtensionParams({
            cornerRadius: newCornerRadius
        });
    }, [
        updateExtensionParams
    ]);
    const cardsActions = (0, $cozmU.useMemo)(()=>({
            addCard: addCard,
            removeCard: removeCard,
            updateMainFormField: updateMainFormField,
            updateCardFormField: updateCardFormField,
            updateCardFormFieldForAllCards: updateCardFormFieldForAllCards,
            updateLayout: updateLayout,
            updateBorderColor: updateBorderColor,
            updateCornerRadius: updateCornerRadius,
            updateCornerStyle: updateCornerStyle
        }), [
        addCard,
        removeCard,
        updateMainFormField,
        updateCardFormField,
        updateCardFormFieldForAllCards,
        updateLayout,
        updateBorderColor,
        updateCornerRadius,
        updateCornerStyle
    ]);
    return {
        cardsParameters: cardsParameters,
        cardsActions: cardsActions
    };
};
module.exports["cardNewParametersV4"] = $9cc1dc91c0ab8fca$export$669fadbeb0d65b03;
module.exports["createNewCardWithDefaultParameters"] = $9cc1dc91c0ab8fca$export$d4fe2f2056b6479c;
module.exports["updateLinkAndConfluencePageId"] = $9cc1dc91c0ab8fca$export$721510bd2cdb9b4f;
module.exports["useCardsExtensionParametersAndActions"] = $9cc1dc91c0ab8fca$export$3c876d2ed5ae458e;

});

parcelRegister("32chb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fodiz = parcelRequire("fodiz");


var $7vK9E = parcelRequire("7vK9E");

var $4aRua = parcelRequire("4aRua");




const $64365de8a577fe11$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    disclaimerMessage: {
        id: "company-hub.cards-extension.ai-disclaimer.disclaimer-message",
        defaultMessage: "AI generated content"
    }
});


const $c5b446c5c3c01483$var$styles = {
    anchor: "_zulp1b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c1txw _4cvr1h6o _1ydc1r31 _1x28glyw _1726nqa1 _9oik1r31 _1bnxglyw _jf4cnqa1"
};
const $c5b446c5c3c01483$export$ddd36803697578b9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== formatMessage) {
        t0 = formatMessage((0, $64365de8a577fe11$export$defe85febe8b728c).disclaimerMessage);
        $[0] = formatMessage;
        $[1] = t0;
    } else t0 = $[1];
    const disclaimerMessage = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            size: "small"
        });
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== disclaimerMessage) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.default), {
            href: "https://www.atlassian.com/trust/atlassian-intelligence",
            xcss: $c5b446c5c3c01483$var$styles.anchor,
            target: "_blank"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            size: "small",
            color: "color.text.subtlest"
        }, disclaimerMessage));
        $[3] = disclaimerMessage;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const disclaimerMessage = formatMessage((0, $64365de8a577fe11$export$defe85febe8b728c).disclaimerMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.default), {
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        xcss: $c5b446c5c3c01483$var$styles.anchor,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        size: "small",
        color: "color.text.subtlest"
    }, disclaimerMessage));
};
module.exports["CardsAIDisclaimer"] = $c5b446c5c3c01483$export$ddd36803697578b9;

});

parcelRegister("3s2S5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4yccB = parcelRequire("4yccB");


var $jlbje = parcelRequire("jlbje");

const $b13f9faa6d57a0da$var$isEmpty = (s)=>!s || s.trim() === '';
const $b13f9faa6d57a0da$export$5af1f6d040dd2f99 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (link, imageSrc)=>{
    const $ = (0, $bDgLe.c)(7);
    const [resolvedUrl, setResolvedUrl] = (0, $cozmU.useState)(undefined);
    let t0;
    if ($[0] !== imageSrc || $[1] !== link) {
        t0 = $b13f9faa6d57a0da$var$isEmpty(imageSrc) && !!link && (0, $jlbje.isLoomLink)(link);
        $[0] = imageSrc;
        $[1] = link;
        $[2] = t0;
    } else t0 = $[2];
    const shouldRefetch = t0;
    let t1;
    let t2;
    if ($[3] !== link || $[4] !== shouldRefetch) {
        t1 = ()=>{
            if (!shouldRefetch || !link) {
                setResolvedUrl(undefined);
                return;
            }
            let cancelled = false;
            const client = new (0, $4yccB.default)();
            client.fetchData(link).then((data)=>{
                if (cancelled) return;
                const url = data?.data?.image?.url;
                if (url) setResolvedUrl(url);
            }).catch($b13f9faa6d57a0da$var$_temp);
            return ()=>{
                cancelled = true;
            };
        };
        t2 = [
            link,
            shouldRefetch
        ];
        $[3] = link;
        $[4] = shouldRefetch;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    if (!$b13f9faa6d57a0da$var$isEmpty(imageSrc)) return imageSrc;
    if (shouldRefetch) return resolvedUrl;
} : (link, imageSrc)=>{
    const [resolvedUrl, setResolvedUrl] = (0, $cozmU.useState)(undefined);
    const shouldRefetch = $b13f9faa6d57a0da$var$isEmpty(imageSrc) && !!link && (0, $jlbje.isLoomLink)(link);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldRefetch || !link) {
            setResolvedUrl(undefined);
            return;
        }
        let cancelled = false;
        const client = new (0, $4yccB.default)();
        client.fetchData(link).then((data)=>{
            if (cancelled) return;
            const url = data?.data?.image?.url;
            if (url) setResolvedUrl(url);
        }).catch(()=>{
        // Ignore fetch errors; component will show no image
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        link,
        shouldRefetch
    ]);
    if (!$b13f9faa6d57a0da$var$isEmpty(imageSrc)) return imageSrc;
    if (shouldRefetch) return resolvedUrl;
    return undefined;
};
function $b13f9faa6d57a0da$var$_temp() {}
module.exports["useLoomThumbnailUrl"] = $b13f9faa6d57a0da$export$5af1f6d040dd2f99;

});

parcelRegister("jlbje", function(module, exports) {
/**
 * Returns true when url is a Loom CDN thumbnail that includes a signed Policy
 * (and thus expires). Such URLs should not be stored in ADF.
 * Public loom URLs do not include a Policy.
 */ const $402d7553b5dc4ef6$export$e9af613851c565cf = (url)=>{
    return typeof url === 'string' && url.includes('cdn.loom.com') && url.includes('Policy');
};
const $402d7553b5dc4ef6$export$fbf81d5b14dce964 = (link)=>{
    if (typeof link !== 'string' || !link) return false;
    try {
        const host = new URL(link).hostname.toLowerCase();
        return (host === 'loom.com' || host === 'www.loom.com') && link.includes('/share/');
    } catch  {
        return false;
    }
};
module.exports["isPrivateLoomImageUrl"] = $402d7553b5dc4ef6$export$e9af613851c565cf;
module.exports["isLoomLink"] = $402d7553b5dc4ef6$export$fbf81d5b14dce964;

});

parcelRegister("5Sbqg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $bIp5p = parcelRequire("bIp5p");


var $dhLnb = parcelRequire("dhLnb");


var $9n61H = parcelRequire("9n61H");


var $aOuIh = parcelRequire("aOuIh");


var $gXR7h = parcelRequire("gXR7h");


var $cT2iI = parcelRequire("cT2iI");


var $je216 = parcelRequire("je216");


var $hjUDQ = parcelRequire("hjUDQ");




const $d1d2b24fb44bd742$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    frameSpotlightLabel: {
        id: "company-hub.carousel-extension.frame-spotlight.label",
        defaultMessage: "frame {positionInSet} of {setSize}"
    }
});


const $346548928aed178e$var$getImage = (src, contentId, alt)=>{
    return src ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dhLnb.ImageRenderer), {
        contentId: contentId,
        imageSrc: src,
        imageAlt: alt,
        shouldShowExternalSiteImage: true
    }) : null;
};
const $346548928aed178e$var$styles = {
    frameStyles: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1hu1v2br"
};
const $346548928aed178e$export$d6098952608bbca6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(45);
    const { testId: testId, contentId: contentId, source: source, link: link, title: title, description: description, backgroundColor: t1, textColor: t2, height: height, layout: t3, imageData: imageData, imageAltText: imageAltText, width: width, imageWidthPercentage: imageWidthPercentage, buttonStyle: t4, buttonText: buttonText, hasRoundedCorners: hasRoundedCorners, cornerRadiusOverride: cornerRadiusOverride, index: t5, selectedFrameIndex: t6, frameSetLength: t7, extensionLocalId: extensionLocalId } = t0;
    const backgroundColor = t1 === undefined ? "var(--ds-background-input, #FFFFFF)" : t1;
    const textColor = t2 === undefined ? (0, $cT2iI.frameNewParametersV2).textColor : t2;
    const layout = t3 === undefined ? (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_LEFT : t3;
    const buttonStyle = t4 === undefined ? (0, $cT2iI.frameNewParametersV2).buttonStyle : t4;
    const index = t5 === undefined ? 0 : t5;
    const selectedFrameIndex = t6 === undefined ? -1 : t6;
    const frameSetLength = t7 === undefined ? 1 : t7;
    const intl = (0, $kSwu1.useIntl)();
    const cardRef = (0, $cozmU.useRef)(null);
    const [t8] = (0, $bIp5p.useExtensionsState)();
    const { selectedExtensionLocalId: selectedExtensionLocalId } = t8;
    const resolvedImageData = (0, $je216.useResolveImage)(link, imageData);
    let t10;
    let t9;
    if ($[0] !== extensionLocalId || $[1] !== index || $[2] !== selectedExtensionLocalId || $[3] !== selectedFrameIndex) {
        t9 = ()=>{
            if (cardRef.current && selectedFrameIndex === index && (!selectedExtensionLocalId || extensionLocalId === selectedExtensionLocalId)) cardRef.current.scrollIntoView({
                behavior: "smooth",
                block: "nearest",
                inline: "nearest"
            });
        };
        t10 = [
            selectedFrameIndex,
            index,
            extensionLocalId,
            selectedExtensionLocalId
        ];
        $[0] = extensionLocalId;
        $[1] = index;
        $[2] = selectedExtensionLocalId;
        $[3] = selectedFrameIndex;
        $[4] = t10;
        $[5] = t9;
    } else {
        t10 = $[4];
        t9 = $[5];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $w6R6I.cx)($346548928aed178e$var$styles.frameStyles);
        $[6] = t11;
    } else t11 = $[6];
    let t12;
    if ($[7] !== width) {
        t12 = {
            width: width,
            minWidth: "100%"
        };
        $[7] = width;
        $[8] = t12;
    } else t12 = $[8];
    let t13;
    if ($[9] !== frameSetLength || $[10] !== index || $[11] !== intl) {
        t13 = intl.formatMessage((0, $d1d2b24fb44bd742$export$defe85febe8b728c).frameSpotlightLabel, {
            positionInSet: index + 1,
            setSize: frameSetLength
        });
        $[9] = frameSetLength;
        $[10] = index;
        $[11] = intl;
        $[12] = t13;
    } else t13 = $[12];
    const t14 = `${(0, $gXR7h.ARIA_CONTROLS_PREFIX)}${extensionLocalId}${index}`;
    let t15;
    if ($[13] !== contentId || $[14] !== imageAltText || $[15] !== resolvedImageData) {
        t15 = $346548928aed178e$var$getImage(resolvedImageData, contentId, imageAltText);
        $[13] = contentId;
        $[14] = imageAltText;
        $[15] = resolvedImageData;
        $[16] = t15;
    } else t15 = $[16];
    const t16 = !!link;
    let t17;
    if ($[17] !== buttonStyle || $[18] !== buttonText || $[19] !== description || $[20] !== imageWidthPercentage || $[21] !== layout || $[22] !== link || $[23] !== source || $[24] !== t16 || $[25] !== textColor || $[26] !== title || $[27] !== width) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9n61H.SpotlightContent), {
            title: title,
            description: description,
            layout: layout,
            textColor: textColor,
            isButtonShown: t16,
            buttonStyle: buttonStyle,
            buttonText: buttonText,
            link: link,
            width: width,
            source: source,
            imageWidthPercentage: imageWidthPercentage
        });
        $[17] = buttonStyle;
        $[18] = buttonText;
        $[19] = description;
        $[20] = imageWidthPercentage;
        $[21] = layout;
        $[22] = link;
        $[23] = source;
        $[24] = t16;
        $[25] = textColor;
        $[26] = title;
        $[27] = width;
        $[28] = t17;
    } else t17 = $[28];
    let t18;
    if ($[29] !== backgroundColor || $[30] !== cornerRadiusOverride || $[31] !== hasRoundedCorners || $[32] !== height || $[33] !== imageWidthPercentage || $[34] !== layout || $[35] !== t15 || $[36] !== t17 || $[37] !== testId || $[38] !== width) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aOuIh.SpotlightLayout), {
            testId: testId,
            backgroundColor: backgroundColor,
            height: height,
            layout: layout,
            image: t15,
            width: width,
            imageWidthPercentage: imageWidthPercentage,
            hasRoundedCorners: hasRoundedCorners,
            cornerRadiusOverride: cornerRadiusOverride
        }, t17);
        $[29] = backgroundColor;
        $[30] = cornerRadiusOverride;
        $[31] = hasRoundedCorners;
        $[32] = height;
        $[33] = imageWidthPercentage;
        $[34] = layout;
        $[35] = t15;
        $[36] = t17;
        $[37] = testId;
        $[38] = width;
        $[39] = t18;
    } else t18 = $[39];
    let t19;
    if ($[40] !== t12 || $[41] !== t13 || $[42] !== t14 || $[43] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t11,
            style: t12,
            "aria-label": t13,
            ref: cardRef,
            id: t14
        }, t18);
        $[40] = t12;
        $[41] = t13;
        $[42] = t14;
        $[43] = t18;
        $[44] = t19;
    } else t19 = $[44];
    return t19;
} : ({ testId: testId, contentId: contentId, source: source, link: link, title: title, description: description, backgroundColor: // default to neutral color for extensions who don't have this param set yet
// (aka v1 carousels), otherwise BG color will be set to a different default
// upon insertion, when Carousel V2 is enabled
backgroundColor = "var(--ds-background-input, #FFFFFF)", textColor: textColor = (0, $cT2iI.frameNewParametersV2)['textColor'], height: height, layout: layout = (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_LEFT, imageData: imageData, imageAltText: imageAltText, width: width, imageWidthPercentage: imageWidthPercentage, buttonStyle: buttonStyle = (0, $cT2iI.frameNewParametersV2)['buttonStyle'], buttonText: buttonText, hasRoundedCorners: hasRoundedCorners, cornerRadiusOverride: cornerRadiusOverride, index: index = 0, selectedFrameIndex: selectedFrameIndex = -1, frameSetLength: frameSetLength = 1, extensionLocalId: extensionLocalId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const cardRef = (0, $cozmU.useRef)(null);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId }] = (0, $bIp5p.useExtensionsState)();
    const resolvedImageData = (0, $je216.useResolveImage)(link, imageData);
    (0, $cozmU.useEffect)(()=>{
        if (cardRef.current && selectedFrameIndex === index && (!selectedExtensionLocalId || extensionLocalId === selectedExtensionLocalId)) cardRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        });
    }, [
        selectedFrameIndex,
        index,
        extensionLocalId,
        selectedExtensionLocalId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($346548928aed178e$var$styles.frameStyles),
        style: {
            width: width,
            minWidth: '100%'
        },
        "aria-label": intl.formatMessage((0, $d1d2b24fb44bd742$export$defe85febe8b728c).frameSpotlightLabel, {
            positionInSet: index + 1,
            setSize: frameSetLength
        }),
        ref: cardRef,
        id: `${(0, $gXR7h.ARIA_CONTROLS_PREFIX)}${extensionLocalId}${index}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aOuIh.SpotlightLayout), {
        testId: testId,
        backgroundColor: backgroundColor,
        height: height,
        layout: layout,
        image: $346548928aed178e$var$getImage(resolvedImageData, contentId, imageAltText),
        width: width,
        imageWidthPercentage: imageWidthPercentage,
        hasRoundedCorners: hasRoundedCorners,
        cornerRadiusOverride: cornerRadiusOverride
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9n61H.SpotlightContent), {
        title: title,
        description: description,
        layout: layout,
        textColor: textColor,
        isButtonShown: !!link,
        buttonStyle: buttonStyle,
        buttonText: buttonText,
        link: link,
        width: width,
        source: source,
        imageWidthPercentage: imageWidthPercentage
    })));
};
module.exports["CarouselLayoutRenderer"] = $346548928aed178e$export$d6098952608bbca6;

});

parcelRegister("je216", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $3s2S5 = parcelRequire("3s2S5");

const $bcb193fec7dfca6e$var$hasValidUrl = (s)=>!!s && s.trim() !== '';
const $bcb193fec7dfca6e$export$71956575015d1f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (link, imageData)=>{
    const loomThumbnailUrl = (0, $3s2S5.useLoomThumbnailUrl)(link, imageData);
    const hasResolved = $bcb193fec7dfca6e$var$hasValidUrl(loomThumbnailUrl);
    const hasStored = $bcb193fec7dfca6e$var$hasValidUrl(imageData);
    if (hasResolved || hasStored) return loomThumbnailUrl ?? imageData ?? "";
    return "";
} : (link, imageData)=>{
    const loomThumbnailUrl = (0, $3s2S5.useLoomThumbnailUrl)(link, imageData);
    const hasResolved = $bcb193fec7dfca6e$var$hasValidUrl(loomThumbnailUrl);
    const hasStored = $bcb193fec7dfca6e$var$hasValidUrl(imageData);
    if (hasResolved || hasStored) return loomThumbnailUrl ?? imageData ?? '';
    return '';
};
module.exports["useResolveImage"] = $bcb193fec7dfca6e$export$71956575015d1f5;

});


//# sourceMappingURL=cards-extension.991a37ae.js.map
